import { ofType } from "redux-observable";
import { filter, map } from "rxjs/operators";
import { TrackedLevels } from "../../constants/TrackedLevels";
import { selectPlayerLevel } from "../../selectors/selectPlayerLevelInfo";
import { actionAppsflyerLevelUp } from "../appsflyer/actionAppsflyer";
import { TypeActionPlayerInfo } from "../info/player/actionPlayerInfo";
import { landingPageMessageHandler } from "../landing-page/landingPageMessageHandler";
export var epicGoogleTagMangerLevelUp = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPlayerInfo.AddLevel), filter(function () {
        var level = selectPlayerLevel(state$.value);
        return TrackedLevels.some(function (value) { return value === level; });
    }), map(function () {
        var level = selectPlayerLevel(state$.value);
        landingPageMessageHandler.onPlayerLevelUp(level);
        return actionAppsflyerLevelUp(level);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/google-tag-manager/epicGoogleTagMangerLevelUp.ts
// module id = 1886
// module chunks = 3